import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import Cookies from 'js-cookie'

//Account Redux states
import {
  FETCH_COUNTRY,
  FETCH_COUNTRY_AND_STATES_LIST,
  FETCH_COUNTRY_LIST,
  REGISTER_USER,
  REGISTER_USER_RESEND,
} from "./actionTypes"
import {
  registerUserSuccessful,
  registerUserFailed,
  registerUserApiError,
  setCountryList,
  setCountryAndStatesList,
} from "./actions"

//Include Both Helper File with needed methods
import {
  Countries,
  CountriesAndStates,
  LystfaceSignup,
  LystfaceSignupResend,
} from "../../../helpers/lystface_helper"

// initialize relavant method of both Auth

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
  try {
    const UserSignuped = yield call(LystfaceSignup, user)
    const Payload = { ...UserSignuped, plan_id: user?.plan_id, userpwd: user?.pwd }
    if (UserSignuped.responseCode == true) {
      Cookies.set("RESEND_ID", user?.cmp_email)
      yield put(registerUserSuccessful(Payload))
    } else {
      yield put(registerUserFailed(UserSignuped.responseMessage))
    }
  } catch (e) {
    yield put(registerUserFailed('There was an error signing up,please try again later!'))
    yield put(registerUserApiError())
  }
}
function* registerUserResend({ payload: { user, history } }) {
  try {
    const UserSignedUpResend = yield call(LystfaceSignupResend, user)
    if (UserSignedUpResend.responseCode == true) {
      yield put(registerUserSuccessful({ ...UserSignedUpResend, from: history ? history : null }))
    } else {
      yield put(registerUserFailed(UserSignedUpResend.responseMessage))
    }
  } catch (e) {
    console.log(e)
    yield put(registerUserFailed("There was an error sending a verification link, please try again later!"))
  }
}

function* fetchCountryList({ payload: { user, history } }) {
  try {
    const data = yield call(Countries)
    const modifiedData = data.response?.countries.map(ele => { return { label: `${ele.iso_name} (${ele.country_phone_code})`, value: ele?.cid, code: ele.iso_name, id: ele?.nicename, dialCode: ele.country_phone_code } })
    if (data?.responseCode) {
      yield put(setCountryList({ loading: false, list: modifiedData }))
    } else {
      yield put(setCountryList({ loading: false, list: [] }))
    }
  } catch (e) {
    console.log(e)
    yield put(setCountryList({ loading: false, list: [] }))

  }
}
function* fetchCountryAndStatesList({ payload: { user, history } }) {
  try {
    const data = yield call(CountriesAndStates)
    yield put(setCountryAndStatesList({ loading: false, list: data?.Countries }))
  } catch (e) {
    console.log(e)
    yield put(setCountryAndStatesList({ loading: false, list: [] }))

  }
}

function* accountSaga() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(REGISTER_USER_RESEND, registerUserResend)
  yield takeEvery(FETCH_COUNTRY_LIST, fetchCountryList)
  yield takeEvery(FETCH_COUNTRY_AND_STATES_LIST, fetchCountryAndStatesList)
}

export default accountSaga
